import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';

// Standalone entry point. Cloudflare Pages serves dist/standalone/index.html
// and this script. The dexhub-module build does NOT use this file — it
// imports from src/index.ts and is rendered by the dexhub host app.
const root = document.getElementById('root');
if (!root) throw new Error('#root not found');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
